import {v1_PostsLinkStatus_select_column} from '../../generated/types';

const PostsLinkStatus = {
    ...v1_PostsLinkStatus_select_column,
    res: 'v1_PostsLinkStatus',
    comp: {},
    rel: {},
};

export default PostsLinkStatus;
